import { render, staticRenderFns } from "./loginZj.vue?vue&type=template&id=06f700b8&scoped=true&"
import script from "./loginZj.vue?vue&type=script&lang=js&"
export * from "./loginZj.vue?vue&type=script&lang=js&"
import style0 from "./loginZj.vue?vue&type=style&index=0&id=06f700b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f700b8",
  null
  
)

export default component.exports